import { configureStore } from "@reduxjs/toolkit";
import appReducer from "../features/appSlice/appSlice";
import pharmacyServiceReducer from "../features/pharmacyServiceSlice/pharmacyServiceSlice";
import documentReducer from "../features/documentServiceSlice/documentServiceSlice";
import teamReducer from "../features/teamSlice/teamSlice";
import clinicalChecksReducer from "../features/clinicalChecksSlice/clinicalChecksSlice";
import generalsReducer from "../features/generalsSlice/generalsSlice";
import billingReducer from "../features/billingSlice/billingSlice";
import locationReducer from "../features/locationSlice/locationSlice";
import templateReducer from "../features/templateSlice/templateSlice";
import orbitReducer from "../features/orbitSlice/orbitSlice";
import nmsReducer from "../features/NmsServiceSlice/NmsServiceSlice";
import memberReducer from "../features/memberSlice/memberSlice";
import typeReducer from "../features/typeSlice/typeSlice";
import consentReducer from "../features/consentSlice/consentSlice";
import onboardingVerificationReducer from "../features/onboardingVerificationSlice/onboardingVerificationSlice";
import scheduleReducer from "../features/scheduleEventsSlice/scheduleEventsSlice";
import reportingReducer from "../features/reportingSlice/reportingSlice";
import patientReducer from "../features/patientSlice/patientSlice";
import marketAppReducer from "../features/marketAppSlice/marketAppSlice";
import patientPrescriptionReducer from "../features/patientPrescriptionSlice/patientPrescriptionSlice";
import companyDocumentReducer from "../features/companyDocumentSlice/companyDocumentSlice";
import companyServiceBillingReducer from "../features/companyServiceBillingSlice/companyServiceBillingSlice";
import patientCommunicationReducer from "../features/patientCommunicationSlice/patientCommunicationSlice";
import analyticsReducer from "../features/analyticsSlice/analyticsSlice";
import pharmacyDashboardReducer from "../features/pharmacyDashboardSlice/pharmacyDashboardSlice";
import pharmacyNotificationsReducer from "../features/pharmacyNotificationsSlice/pharmacyNotificationsSlice";
import dosReducer from "../features/DOSSlice/DOSSlice";
import titanTabReducer from "../features/titanTabSlice/titanTabSlice";
import treatmentPlanReducer from "../features/treatmentPlanSlice/treatmentPlanSlice";
import dashboardKPIReducer from "../features/dashboardKPISlice/dashboardKPISlice";
import mysClaimsReducer from "../features/mysClaimsSlice/mysClaimsSlice";
import travelHealthReducer from "../features/travelHealthSlice/travelHealthSlice";

export const store = configureStore({
  reducer: {
    app: appReducer,
    pharmacyService: pharmacyServiceReducer,
    documentService: documentReducer,
    team: teamReducer,
    clinicalChecks: clinicalChecksReducer,
    general: generalsReducer,
    billing: billingReducer,
    location: locationReducer,
    template: templateReducer,
    orbit: orbitReducer,
    nmsService: nmsReducer,
    member: memberReducer,
    type: typeReducer,
    consent: consentReducer,
    onboardingVerification: onboardingVerificationReducer,
    scheduleEvent: scheduleReducer,
    reporting: reportingReducer,
    patient: patientReducer,
    marketApp: marketAppReducer,
    patientPrescription: patientPrescriptionReducer,
    companyDocument: companyDocumentReducer,
    companyServiceBilling: companyServiceBillingReducer,
    patientCommunication: patientCommunicationReducer,
    analytics: analyticsReducer,
    pharmacyDashboard: pharmacyDashboardReducer,
    pharmacyNotifications: pharmacyNotificationsReducer,
    dos: dosReducer,
    titanTab: titanTabReducer,
    treatmentPlan: treatmentPlanReducer,
    dashboardKPI: dashboardKPIReducer,
    mysClaims: mysClaimsReducer,
    travelHealth: travelHealthReducer,
  },
});

export const { dispatch } = store || {};

export const getDataFromStore = (reducerName, key) => {
  let result = null;
  if (reducerName && key) {
    const state = store.getState();
    if (state[reducerName] !== undefined && state[reducerName] !== null) {
      const reducer = state[reducerName];
      if (reducer[key] !== undefined) {
        result = reducer[key];
      }
    }
  }
  return result;
};
